import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { PlumaLink } from '@customerio/pluma-components/css/components';

// Header "Start your free trial" link: a secondary link reads dark by default,
// so override its color vars to white/grey for the dark header (matches the
// Ember `minimal-app-header` signupLink).
export const signupLink = style(
  {
    vars: {
      [PlumaLink.vars.textColorSecondary]: themeVars.palette['grey-white'],
      [PlumaLink.vars.textColorSecondaryHover]: themeVars.palette['grey-100'],
    },
  },
  'sign-up-log-in-link',
);

// Header bar — fixed 40px tall, matching Ember's `minimal-app-header`.
export const loginHeader = style(
  {
    height: '40px',
  },
  'minimal-app-header',
);

export const container = style(
  {
    width: '100%',
    maxWidth: '480px',
    marginInline: 'auto',
  },
  'container',
);

// ---------------------------------------------------------------------------
// Split-screen layout (form left, splash right). Ported from the Ember
// `referral-splash` (July feature-drop webinar campaign). Fixed palette tokens
// keep the campaign art direction stable across color schemes.
// ---------------------------------------------------------------------------
const DESKTOP = 'screen and (min-width: 1024px)';
const WIDE = 'screen and (min-width: 1200px)';

export const splitMain = style(
  {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    '@media': { [DESKTOP]: { flexDirection: 'row', minHeight: 0 } },
  },
  'split-main',
);

export const splitLeft = style(
  {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${themeVars.space['600']} ${themeVars.space['300']}`,
    '@media': { [DESKTOP]: { overflow: 'auto' } },
  },
  'split-left',
);

export const splitRight = style(
  {
    display: 'flex',
    backgroundColor: themeVars.palette['brand-forest-dark'],
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${themeVars.space['600']} ${themeVars.space['300']}`,
    '@media': {
      [DESKTOP]: { flex: 1, maxWidth: '50%', padding: `${themeVars.space['600']} ${themeVars.space['400']}` },
      [WIDE]: { flexBasis: '60%', maxWidth: '60%' },
    },
  },
  'split-right',
);
